import { Routes } from '@angular/router';
import { AuthGuard } from '../auth.guard';

export const monitorRoutes: Routes = [
    {
        path: 'monitor',
        loadComponent: () => import('./monitor.component').then(m => m.MonitorComponent),
        canActivate: [AuthGuard],
        children: [
            {
              path:'',
              canActivate: [AuthGuard],
              loadComponent: () => import('./dashboard/dashboard.component').then(m => m.MonitorDashboardComponent)
            },
            {
                path:'dashboard',
                canActivate: [AuthGuard],
                loadComponent: () => import('./dashboard/dashboard.component').then(m => m.MonitorDashboardComponent)
            },
            {
                path:'dashboard/setting',
                canActivate: [AuthGuard],
                loadComponent: () => import('./dashboard-setting/dashboard-setting.component').then(m => m.MonitorDashboardSettingComponent)
            },
            {
                path:'alarms',
                canActivate: [AuthGuard],
                loadComponent: () => import('./alarm/alarm.component').then(m => m.MonitorAlarmComponent)
            },
            {
                path:'alarms/setting',
                canActivate: [AuthGuard],
                loadComponent: () => import('./alarm-setting/alarm-setting.component').then(m => m.MonitorAlarmSettingComponent)
            },
            {
                path:'change-password',
                canActivate: [AuthGuard],
                loadComponent: () => import('./user/change-password/change-password.component').then(m => m.MonitorChangePasswordComponent)
            }
        ]
    }
];
